<div [dir]="languageService.dir | async">
  <app-navbar *ngIf="appstate.get('hostEnv') !== 'flutter'"></app-navbar>
  <div #content>
    <router-outlet></router-outlet>
  </div>
  <app-remote-transfer-dialog></app-remote-transfer-dialog>
  <app-cookie-consent></app-cookie-consent>
  <app-footer></app-footer>
</div>
